import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import Products from "@/pages/Products";
import Analytics from "@/pages/Analytics";
import AdGenerator from "@/pages/AdGenerator";
import Chatbot from "@/pages/Chatbot";
import Settings from "@/pages/Settings";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Download from "@/pages/Download";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ChatWidget from "@/components/ChatWidget";

function WidgetPage() {
  return (
    <div className="h-screen w-screen bg-arena-bg">
      <ChatWidget />
    </div>
  );
}

/**
 * Detect session_id in the URL hash synchronously during render — critical to
 * process OAuth callback BEFORE any routing/useEffect race conditions.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public routes (no auth) */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/widget" element={<WidgetPage />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/:productId" element={<Checkout />} />
      <Route path="/download/:grantId" element={<Download />} />
      {/* Protected admin shell */}
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="products" element={<Products />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="ads" element={<AdGenerator />} />
        <Route path="chatbot" element={<Chatbot />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #222",
            color: "#ededed",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          }
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
